"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Observable } from 'rxjs/Observable';
var ObjectObservable = /** @class */ (function (_super) {
    __extends(ObjectObservable, _super);
    function ObjectObservable(ref$, apiHttp, store, source) {
        var _this = _super.call(this) || this;
        _this.ref$ = ref$;
        _this.apiHttp = apiHttp;
        _this.store = store;
        _this.source = source;
        return _this;
    }
    ObjectObservable.prototype.lift = function (operator) {
        var observable = new ObjectObservable(this.ref$, this.apiHttp, this.store, this);
        observable.operator = operator;
        return observable;
    };
    ObjectObservable.prototype.set = function (value) {
        return Observable.of(undefined);
    };
    ObjectObservable.prototype.update = function (value) {
        return Observable.of(undefined);
    };
    ObjectObservable.prototype.remove = function () {
        return Observable.of(undefined);
    };
    return ObjectObservable;
}(Observable));
export { ObjectObservable };



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/object-observable.ts.pre-build-optimizer.js